import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import { GameAssets } from "src/shared/util/GameAssets";
import { delay } from "src/shared/util/UtilFunctions";
import gsap from "gsap";
import { soundManager } from "./shared/UI/SoundManager";

export class RetriggerPopup extends PIXI.Container {
    private skeleton: Spine;
    private lifeSprite: PIXI.Sprite;
    private counterText: PIXI.BitmapText;
    private descriptionText: PIXI.Text;
    private backgroundLayer: PIXI.Graphics;
    private content: PIXI.Container;

    constructor() {
        super();

        this.backgroundLayer = new PIXI.Graphics()
            .rect(-2000, -2000, 4000, 4000)
            .fill(0);
        this.backgroundLayer.alpha = 0.7;

        this.skeleton = Spine.from({
            skeleton: `counterJson`,
            atlas: `counterAtlas`,
        });
        this.skeleton.state.setAnimation(0, "idle", true);
        this.skeleton.scale.set(0.3);

        this.lifeSprite = new PIXI.Sprite(
            GameAssets.textures.gameAtlas.textures["life.png"],
        );
        this.lifeSprite.anchor.set(0.5);
        this.lifeSprite.scale.set(2);
        this.lifeSprite.position.set(0, -100);

        this.counterText = new PIXI.BitmapText({
            text: "5",
            style: {
                fontSize: 40,
                fontFamily: "winFont",
            },
        });
        this.counterText.position.set(0, 0);
        this.counterText.anchor.set(0.5);

        this.descriptionText = new PIXI.Text({
            text: `You've received 5 more free spins`,
            style: {
                fontSize: 50,
                align: "center",
                fontFamily: "TextFont",
                fill: "0xfad035",
                stroke: { color: "0x4a1850", width: 4, join: "round" },
            },
        });

        this.descriptionText.position.set(0, 250);
        this.descriptionText.anchor.set(0.5);

        this.addChild(this.backgroundLayer);

        this.content = new PIXI.Container();
        this.addChild(this.content);

        this.content.addChild(this.skeleton);
        this.content.addChild(this.lifeSprite);
        this.content.addChild(this.counterText);
        this.content.addChild(this.descriptionText);
    }

    async show(scattersCollected: number) {
        this.visible = true;
        this.content.alpha = 0;
        gsap.to(this.content, { alpha: 1, ease: "back.out", duration: 0.5 });
        this.counterText.text = scattersCollected.toString();
        this.skeleton.state.setAnimation(0, "glow", false);
        await soundManager.playSound("win5MoreSpins");
        await delay(1500);
        gsap.to(this.content, {
            alpha: 0,
            duration: 0.5,
            ease: "circ.in",
            onComplete: () => {
                this.visible = false;
            },
        });
    }
}
